// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"audienceVoiceMessage_mainContainer__waIuF","userImg":"audienceVoiceMessage_userImg__2NLC7","messageContainer":"audienceVoiceMessage_messageContainer__2rAQJ"};